import { render, staticRenderFns } from "./gmv.vue?vue&type=template&id=25bb2399&scoped=true"
import script from "./gmv.vue?vue&type=script&lang=js"
export * from "./gmv.vue?vue&type=script&lang=js"
import style0 from "./gmv.vue?vue&type=style&index=0&id=25bb2399&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb2399",
  null
  
)

export default component.exports